<template>
  <div>

    <table class="table" v-if="changed_new_cost" >
      <tbody>

      <div v-for=" new_cost in changed_new_cost" :key=' new_cost.manufacturer.id ' style="margin-top:10px;">

        <span class="cust-button" @click="toggle(new_cost['manufacturer']['id'])">toggle {{ new_cost['manufacturer']['name'] }}</span>
        <div v-show="show(new_cost['manufacturer']['id'])">
          <tr>
            <td width="40%" style="cursor:pointer;">
              <h5>{{ new_cost['manufacturer']['name'] }} ({{ new_cost['manufacturer']['id'] }})</h5>
              <h3>{{ new_cost['model'] }} ({{ new_cost['printer'] ? new_cost['printer']['id'] : null }})</h3>
            </td>
            <td><b>Purchase</b></td>
            <td><b>1</b></td>
            <td><b>2</b></td>
            <td><b>3</b></td>
            <td><b>4</b></td>
            <td><b>5</b></td>
            <td><b>6</b></td>
          </tr>

          <tr>
            <th><b>C16 {{ letter }}</b> Kits cost</th>
            <td>&pound;{{ new_cost['kit_cost'] ? new_cost['kit_cost'] : 0 }} </td>
            <td colspan="6"></td>
          </tr>
          <tr>
            <th><b>C17</b> Service Cost</th>
            <td>&pound;{{ new_cost['service_cost']['purchase'] }} </td>
            <td><b>L1</b> &pound;{{ new_cost['service_cost']['lease'][0] }}</td>
            <td><b>L2</b> &pound;{{ new_cost['service_cost']['lease'][1] }}</td>
            <td><b>L3</b> &pound;{{ new_cost['service_cost']['lease'][2] }}</td>
            <td><b>L4</b> &pound;{{ new_cost['service_cost']['lease'][3] }}</td>
            <td><b>L5</b> &pound;{{ new_cost['service_cost']['lease'][4] }}</td>
            <td><b>L6</b> &pound;{{ new_cost['service_cost']['lease'][5] }}</td>
          </tr>
          <tr>
            <th>Annual incremental Service Cost</th>
            <td>&pound;{{ new_cost['annual_incremental_service_cost']['purchase'] }}</td>
            <td>&pound;{{ new_cost['annual_incremental_service_cost']['lease'][0] }}</td>
            <td>&pound;{{ new_cost['annual_incremental_service_cost']['lease'][1] }}</td>
            <td>&pound;{{ new_cost['annual_incremental_service_cost']['lease'][2] }}</td>
            <td>&pound;{{ new_cost['annual_incremental_service_cost']['lease'][3] }}</td>
            <td>&pound;{{ new_cost['annual_incremental_service_cost']['lease'][4] }}</td>
            <td>&pound;{{ new_cost['annual_incremental_service_cost']['lease'][5] }}</td>
          </tr>

          <tr>
            <th><b>C18</b> Settlement cost</th>
            <td>&pound;{{ new_cost['settlement_cost']['purchase'] }} </td>
            <td>&pound;{{ new_cost['settlement_cost']['lease'][0] }}</td>
            <td>&pound;{{ new_cost['settlement_cost']['lease'][1] }}</td>
            <td>&pound;{{ new_cost['settlement_cost']['lease'][2] }}</td>
            <td>&pound;{{ new_cost['settlement_cost']['lease'][3] }}</td>
            <td>&pound;{{ new_cost['settlement_cost']['lease'][4] }}</td>
            <td>&pound;{{ new_cost['settlement_cost']['lease'][5] }}</td>
          </tr>

          <tr>
            <th><b>C19 {{ letter }}</b> SCALE cost</th>
            <td>&pound;{{ new_cost['scale_cost'] }} </td>
            <td colspan="6"></td>
          </tr>

          <tr>
            <th><b>C20</b> SCALE SERVICE</th>
            <td>&pound;{{ new_cost['scale_service']['purchase'] }} </td>
            <td><b>L7</b> &pound;{{ new_cost['scale_service']['lease'][0] }}</td>
            <td><b>L8</b> &pound;{{ new_cost['scale_service']['lease'][1] }}</td>
            <td><b>L9</b> &pound;{{ new_cost['scale_service']['lease'][2] }}</td>
            <td><b>L10</b> &pound;{{ new_cost['scale_service']['lease'][3] }}</td>
            <td><b>L11</b> &pound;{{ new_cost['scale_service']['lease'][4] }}</td>
            <td><b>L12</b> &pound;{{ new_cost['scale_service']['lease'][5] }}</td>
          </tr>

          <tr>
            <th>Annual incremental SCALE SERVICE</th>
            <td>&pound;{{ new_cost['annual_incremental_scale_service']['purchase'] }}</td>
            <td>&pound;{{ new_cost['annual_incremental_scale_service']['lease'][0] }}</td>
            <td>&pound;{{ new_cost['annual_incremental_scale_service']['lease'][1] }}</td>
            <td>&pound;{{ new_cost['annual_incremental_scale_service']['lease'][2] }}</td>
            <td>&pound;{{ new_cost['annual_incremental_scale_service']['lease'][3] }}</td>
            <td>&pound;{{ new_cost['annual_incremental_scale_service']['lease'][4] }}</td>
            <td>&pound;{{ new_cost['annual_incremental_scale_service']['lease'][5] }}</td>
          </tr>

          <tr>
            <th><b>C21</b> Upgrade scale cost</th>
            <td>&pound;{{ new_cost['upgraded_scale_cost'] }} </td>
            <td colspan="6"></td>
          </tr>

          <tr>
            <th><b>C22</b> upgraded scale service</th>
            <td>&pound;{{ new_cost['upgraded_scale_service'] }} </td>
            <td colspan="6"></td>
          </tr>

          <tr>
            <th><b>C23</b> DIFFERENTIAL WEIGHING</th>
            <td>&pound;{{ new_cost['differential_weighing'] }} </td>
            <td colspan="6"></td>
          </tr>

          <tr>
            <th><b>C24</b> Departmental accounting</th>
            <td>&pound;{{ new_cost['departmental_accounting'] }} </td>
            <td colspan="6"></td>
          </tr>

          <tr>
            <th><b>C25</b> ENGINEER INSTALLATION</th>
            <td>&pound;{{ new_cost['engineer_installation'] }} </td>
            <td colspan="6"></td>
          </tr>

          <tr>
            <th><b>C26</b> Logo and return address</th>
            <td>&pound;{{ new_cost['logo_and_return_address'] }} </td>
            <td colspan="6"></td>
          </tr>

          <tr>
            <th><b>C27</b> business mail advanced</th>
            <td>&pound;{{ new_cost['business_mail_advanced'] }} </td>
            <td colspan="6"></td>
          </tr>

          <tr>
            <th><b>C28</b> connectivity kit cost</th>
            <td>&pound;{{ new_cost['connectivity_kit_cost'] }} </td>
            <td colspan="6"></td>
          </tr>

          <tr>
            <th><b>C29</b> connectivity kit service cost</th>
            <td>&pound;{{ new_cost['connectivity_kit_service_cost']['purchase'] }} </td>
            <td><b>L13</b> &pound;{{ new_cost['connectivity_kit_service_cost']['lease'][0] }}</td>
            <td><b>L14</b> &pound;{{ new_cost['connectivity_kit_service_cost']['lease'][1] }}</td>
            <td><b>L15</b> &pound;{{ new_cost['connectivity_kit_service_cost']['lease'][2] }}</td>
            <td><b>L16</b> &pound;{{ new_cost['connectivity_kit_service_cost']['lease'][3] }}</td>
            <td><b>L17</b> &pound;{{ new_cost['connectivity_kit_service_cost']['lease'][4] }}</td>
            <td><b>L18</b> &pound;{{ new_cost['connectivity_kit_service_cost']['lease'][5] }}</td>
          </tr>

          <tr>
            <th>Annual incremental connectivity kit service cost</th>
            <td>&pound;{{ new_cost['annual_incremental_connectivity_kit_service_cost']['purchase'] }}</td>
            <td>&pound;{{ new_cost['annual_incremental_connectivity_kit_service_cost']['lease'][0] }}</td>
            <td>&pound;{{ new_cost['annual_incremental_connectivity_kit_service_cost']['lease'][1] }}</td>
            <td>&pound;{{ new_cost['annual_incremental_connectivity_kit_service_cost']['lease'][2] }}</td>
            <td>&pound;{{ new_cost['annual_incremental_connectivity_kit_service_cost']['lease'][3] }}</td>
            <td>&pound;{{ new_cost['annual_incremental_connectivity_kit_service_cost']['lease'][4] }}</td>
            <td>&pound;{{ new_cost['annual_incremental_connectivity_kit_service_cost']['lease'][5] }}</td>
          </tr>

          <tr>
            <th><b>C30</b> inbound courier/parcel tracking cost</th>
            <td>&pound;{{ new_cost['inbound_courier_parcel_tracking_cost'] }}</td>
            <td colspan="6"></td>
          </tr>

          <tr>
            <th><b>C31</b> inbound courier/parcel tracking service cost</th>
            <td>&pound;{{ new_cost['inbound_courier_parcel_tracking_service_cost']['purchase'] }} </td>
            <td><b>L19</b> &pound;{{ new_cost['inbound_courier_parcel_tracking_service_cost']['lease'][0] }}</td>
            <td><b>L20</b> &pound;{{ new_cost['inbound_courier_parcel_tracking_service_cost']['lease'][1] }}</td>
            <td><b>L21</b> &pound;{{ new_cost['inbound_courier_parcel_tracking_service_cost']['lease'][2] }}</td>
            <td><b>L22</b> &pound;{{ new_cost['inbound_courier_parcel_tracking_service_cost']['lease'][3] }}</td>
            <td><b>L23</b> &pound;{{ new_cost['inbound_courier_parcel_tracking_service_cost']['lease'][4] }}</td>
            <td><b>L24</b> &pound;{{ new_cost['inbound_courier_parcel_tracking_service_cost']['lease'][5] }}</td>
          </tr>

          <tr>
            <th>Annual incremental inbound courier/parcel tracking service cost</th>
            <td>&pound;{{ new_cost['annual_incremental_inbound_courier_parcel_tracking_service_cost']['purchase'] }}</td>
            <td>&pound;{{ new_cost['annual_incremental_inbound_courier_parcel_tracking_service_cost']['lease'][0] }}</td>
            <td>&pound;{{ new_cost['annual_incremental_inbound_courier_parcel_tracking_service_cost']['lease'][1] }}</td>
            <td>&pound;{{ new_cost['annual_incremental_inbound_courier_parcel_tracking_service_cost']['lease'][2] }}</td>
            <td>&pound;{{ new_cost['annual_incremental_inbound_courier_parcel_tracking_service_cost']['lease'][3] }}</td>
            <td>&pound;{{ new_cost['annual_incremental_inbound_courier_parcel_tracking_service_cost']['lease'][4] }}</td>
            <td>&pound;{{ new_cost['annual_incremental_inbound_courier_parcel_tracking_service_cost']['lease'][5] }}</td>
          </tr>

          <tr>
            <th><b>C32</b> outbound shipping application</th>
            <td>&pound;{{ new_cost['outbound_shipping_application'] }} </td>
            <td colspan="6"></td>
          </tr>

          <tr>
            <th><b>C33</b> Service Upgrade</th>
            <td>&pound;{{ new_cost['service_upgrade']['purchase'] }} </td>
            <td><b>L25</b> &pound;{{ new_cost['service_upgrade']['lease'][0] }}</td>
            <td><b>L26</b> &pound;{{ new_cost['service_upgrade']['lease'][1] }}</td>
            <td><b>L27</b> &pound;{{ new_cost['service_upgrade']['lease'][2] }}</td>
            <td><b>L28</b> &pound;{{ new_cost['service_upgrade']['lease'][3] }}</td>
            <td><b>L29</b> &pound;{{ new_cost['service_upgrade']['lease'][4] }}</td>
            <td><b>L30</b> &pound;{{ new_cost['service_upgrade']['lease'][5] }}</td>
          </tr>

          <tr>
            <th>Annual incremental Service Upgrade</th>
            <td>&pound;{{ new_cost['annual_incremental_service_upgrade']['purchase'] }}</td>
            <td>&pound;{{ new_cost['annual_incremental_service_upgrade']['lease'][0] }}</td>
            <td>&pound;{{ new_cost['annual_incremental_service_upgrade']['lease'][1] }}</td>
            <td>&pound;{{ new_cost['annual_incremental_service_upgrade']['lease'][2] }}</td>
            <td>&pound;{{ new_cost['annual_incremental_service_upgrade']['lease'][3] }}</td>
            <td>&pound;{{ new_cost['annual_incremental_service_upgrade']['lease'][4] }}</td>
            <td>&pound;{{ new_cost['annual_incremental_service_upgrade']['lease'][5] }}</td>
          </tr>

          <tr>
            <th><b>C34</b> Consumables ink cost</th>
            <td>&pound;{{ new_cost['consumables_ink_cost'] }}</td>
            <td colspan="6"></td>
          </tr>

          <tr>
            <th><b>C35</b> Consumable label cost</th>
            <td>&pound;{{ new_cost['consumable_label_cost'] }}</td>
            <td colspan="6"></td>
          </tr>

          <tr>
            <th><b>C36</b> Postage Recredit costs</th>
            <td>&pound;{{ new_cost['postage_recredit_costs'] }}</td>
            <td colspan="6"></td>
          </tr>

          <tr>
            <th><b>C37</b> Postage Savings</th>
            <td>&pound;{{ new_cost['postage_savings'] }}</td>
            <td colspan="6"></td>
          </tr>

          <tr>
            <th><b>C38</b> Lease Setup fee</th>
            <td>&pound;{{ new_cost['lease_setup_fee'] }}</td>
            <td colspan="6"></td>
          </tr>

          <tr>
            <th><b>C39</b> Lease Annual admin fee</th>
            <td>&pound;{{ new_cost['lease_annual_admin_fee']['purchase'] }}</td>
            <td>&pound;{{ new_cost['lease_annual_admin_fee']['lease'][0] }}</td>
            <td>&pound;{{ new_cost['lease_annual_admin_fee']['lease'][1] }}</td>
            <td>&pound;{{ new_cost['lease_annual_admin_fee']['lease'][2] }}</td>
            <td>&pound;{{ new_cost['lease_annual_admin_fee']['lease'][3] }}</td>
            <td>&pound;{{ new_cost['lease_annual_admin_fee']['lease'][4] }}</td>
            <td>&pound;{{ new_cost['lease_annual_admin_fee']['lease'][5] }}</td>
          </tr>

          <tr>
            <th><b>C40</b> MARGIN</th>
            <td>&pound;{{ new_cost['margin'] }}</td>
            <td colspan="6"></td>
          </tr>

          <tr>
            <th><b>C41</b> PROMOTIONAL SAVING 1</th>
            <td>&pound;{{ new_cost['promotional_saving_1'] }}</td>
            <td colspan="6"></td>
          </tr>
          <tr>
            <th><b>C42</b> PROMOTIONAL SAVING 2</th>
            <td>&pound;{{ new_cost['promotional_saving_2'] }}</td>
            <td colspan="6"></td>
          </tr>
          <tr>
            <th><b>C43</b> Lease adhoc costs</th>
            <td>&pound;{{ new_cost['lease_adhoc_costs'] }}</td>
            <td colspan="6"></td>
          </tr>
          <tr>
            <th><b>C44</b> Total of adhoc costs</th>
            <td>&pound;{{ new_cost['total_of_adhoc_costs'] }}</td>
            <td colspan="6"></td>
          </tr>

          <tr>
            <th><b>C45</b> Total Equipment cost </th>
            <td>&pound;{{ new_cost['total_equipment_cost']['purchase'] }}</td>
            <td>&pound;{{ new_cost['total_equipment_cost']['lease'][0] }}</td>
            <td>&pound;{{ new_cost['total_equipment_cost']['lease'][1] }}</td>
            <td>&pound;{{ new_cost['total_equipment_cost']['lease'][2] }}</td>
            <td>&pound;{{ new_cost['total_equipment_cost']['lease'][3] }}</td>
            <td>&pound;{{ new_cost['total_equipment_cost']['lease'][4] }}</td>
            <td>&pound;{{ new_cost['total_equipment_cost']['lease'][5] }}</td>
          </tr>
          <tr>
            <th><b>C46</b> Total Service cost </th>
            <td>&pound;{{ new_cost['total_service_cost']['purchase'] }}</td>
            <td>&pound;{{ new_cost['total_service_cost']['lease'][0] }}</td>
            <td>&pound;{{ new_cost['total_service_cost']['lease'][1] }}</td>
            <td>&pound;{{ new_cost['total_service_cost']['lease'][2] }}</td>
            <td>&pound;{{ new_cost['total_service_cost']['lease'][3] }}</td>
            <td>&pound;{{ new_cost['total_service_cost']['lease'][4] }}</td>
            <td>&pound;{{ new_cost['total_service_cost']['lease'][5] }}</td>
          </tr>
          <tr>
            <th><b>C47</b> Total Savings Over Term (Calculated on 5 years if purchased) </th>
            <td>&pound;{{ new_cost['total_savings_over_term']['purchase'] }}</td>
            <td>&pound;{{ new_cost['total_savings_over_term']['lease'][0] }}</td>
            <td>&pound;{{ new_cost['total_savings_over_term']['lease'][1] }}</td>
            <td>&pound;{{ new_cost['total_savings_over_term']['lease'][2] }}</td>
            <td>&pound;{{ new_cost['total_savings_over_term']['lease'][3] }}</td>
            <td>&pound;{{ new_cost['total_savings_over_term']['lease'][4] }}</td>
            <td>&pound;{{ new_cost['total_savings_over_term']['lease'][5] }}</td>
          </tr>
          <tr>
            <th><b>C48</b> Effective Annual Saving </th>
            <td>&pound;{{ new_cost['effective_annual_saving']['purchase'] }}</td>
            <td>&pound;{{ new_cost['effective_annual_saving']['lease'][0] }}</td>
            <td>&pound;{{ new_cost['effective_annual_saving']['lease'][1] }}</td>
            <td>&pound;{{ new_cost['effective_annual_saving']['lease'][2] }}</td>
            <td>&pound;{{ new_cost['effective_annual_saving']['lease'][3] }}</td>
            <td>&pound;{{ new_cost['effective_annual_saving']['lease'][4] }}</td>
            <td>&pound;{{ new_cost['effective_annual_saving']['lease'][5] }}</td>
          </tr>
          <tr>
            <th><b>C49</b> Total effective cost</th>
            <td>{{ new_cost['total_effective_cost']['purchase'] }}</td>
            <td>{{ new_cost['total_effective_cost']['lease'][0] }}</td>
            <td>{{ new_cost['total_effective_cost']['lease'][1] }}</td>
            <td>{{ new_cost['total_effective_cost']['lease'][2] }}</td>
            <td>{{ new_cost['total_effective_cost']['lease'][3] }}</td>
            <td>{{ new_cost['total_effective_cost']['lease'][4] }}</td>
            <td>{{ new_cost['total_effective_cost']['lease'][5] }}</td>
          </tr>
          <tr>
            <th><b>C50</b> Switch and save</th>
            <td>{{ new_cost['switch_and_save']['purchase'] }}</td>
            <td>{{ new_cost['switch_and_save']['lease'][0] }}</td>
            <td>{{ new_cost['switch_and_save']['lease'][1] }}</td>
            <td>{{ new_cost['switch_and_save']['lease'][2] }}</td>
            <td>{{ new_cost['switch_and_save']['lease'][3] }}</td>
            <td>{{ new_cost['switch_and_save']['lease'][4] }}</td>
            <td>{{ new_cost['switch_and_save']['lease'][5] }}</td>
          </tr>
          <tr>
            <th><b>C51</b> Saving over term</th>
            <td>{{ new_cost['saving_over_term']['purchase'] }}</td>
            <td>{{ new_cost['saving_over_term']['lease'][0] }}</td>
            <td>{{ new_cost['saving_over_term']['lease'][1] }}</td>
            <td>{{ new_cost['saving_over_term']['lease'][2] }}</td>
            <td>{{ new_cost['saving_over_term']['lease'][3] }}</td>
            <td>{{ new_cost['saving_over_term']['lease'][4] }}</td>
            <td>{{ new_cost['saving_over_term']['lease'][5] }}</td>
          </tr>
          <tr>
            <th><b>C52</b> Total equipment and service cost</th>
            <td>{{ new_cost['total_equipment_and_service_cost']['purchase'] }}</td>
            <td>{{ new_cost['total_equipment_and_service_cost']['lease'][0] }}</td>
            <td>{{ new_cost['total_equipment_and_service_cost']['lease'][1] }}</td>
            <td>{{ new_cost['total_equipment_and_service_cost']['lease'][2] }}</td>
            <td>{{ new_cost['total_equipment_and_service_cost']['lease'][3] }}</td>
            <td>{{ new_cost['total_equipment_and_service_cost']['lease'][4] }}</td>
            <td>{{ new_cost['total_equipment_and_service_cost']['lease'][5] }}</td>
          </tr>
          <tr>
            <th><b>C53</b> Total current cost per annum</th>
            <td>{{ current_costs['total_current_cost_per_annum'] }}</td>
            <td colspan="6"></td>
          </tr>
          <tr>
            <th><b>C54</b> Annual savings available</th>
            <td>{{ new_cost['annual_savings_available']['purchase'] }}</td>
            <td>{{ new_cost['annual_savings_available']['lease'][0] }}</td>
            <td>{{ new_cost['annual_savings_available']['lease'][1] }}</td>
            <td>{{ new_cost['annual_savings_available']['lease'][2] }}</td>
            <td>{{ new_cost['annual_savings_available']['lease'][3] }}</td>
            <td>{{ new_cost['annual_savings_available']['lease'][4] }}</td>
            <td>{{ new_cost['annual_savings_available']['lease'][5] }}</td>
          </tr>
          <tr>
            <th><b>C55</b> Savings over term</th>
            <td>{{ new_cost['savings_over_term']['purchase'] }}</td>
            <td>{{ new_cost['savings_over_term']['lease'][0] }}</td>
            <td>{{ new_cost['savings_over_term']['lease'][1] }}</td>
            <td>{{ new_cost['savings_over_term']['lease'][2] }}</td>
            <td>{{ new_cost['savings_over_term']['lease'][3] }}</td>
            <td>{{ new_cost['savings_over_term']['lease'][4] }}</td>
            <td>{{ new_cost['savings_over_term']['lease'][5] }}</td>
          </tr>
          <tr>
            <th><b>C56</b> Postage savings over term</th>
            <td>{{ new_cost['postage_savings_over_term']['purchase'] }}</td>
            <td>{{ new_cost['postage_savings_over_term']['lease'][0] }}</td>
            <td>{{ new_cost['postage_savings_over_term']['lease'][1] }}</td>
            <td>{{ new_cost['postage_savings_over_term']['lease'][2] }}</td>
            <td>{{ new_cost['postage_savings_over_term']['lease'][3] }}</td>
            <td>{{ new_cost['postage_savings_over_term']['lease'][4] }}</td>
            <td>{{ new_cost['postage_savings_over_term']['lease'][5] }}</td>
          </tr>
          <tr>
            <th><b>C57</b> TME consumable ink cost</th>
            <td>{{ new_cost['tme_consumable_ink_costs'] }}</td>
            <td colspan="6"></td>
          </tr>
          <tr>
            <th><b>C58</b> TME consumable label cost</th>
            <td>{{ new_cost['tme_consumable_label_costs'] }}</td>
            <td colspan="6"></td>
          </tr>
          <tr>
            <th><b>C59</b> Saving vs current rental and service</th>
            <td>{{ new_cost['saving_vs_current_rental_and_service']['purchase'] }}</td>
            <td>{{ new_cost['saving_vs_current_rental_and_service']['lease'][0] }}</td>
            <td>{{ new_cost['saving_vs_current_rental_and_service']['lease'][1] }}</td>
            <td>{{ new_cost['saving_vs_current_rental_and_service']['lease'][2] }}</td>
            <td>{{ new_cost['saving_vs_current_rental_and_service']['lease'][3] }}</td>
            <td>{{ new_cost['saving_vs_current_rental_and_service']['lease'][4] }}</td>
            <td>{{ new_cost['saving_vs_current_rental_and_service']['lease'][5] }}</td>
          </tr>
          <tr>
            <th><b>C60</b> Saving vs current ink</th>
            <td>{{ new_cost['saving_vs_current_ink'] }}</td>
            <td colspan="6"></td>
          </tr>
          <tr>
            <th><b>C61</b> Saving vs current labels</th>
            <td>{{ new_cost['saving_vs_current_labels'] }}</td>
            <td colspan="6"></td>
          </tr>
          <tr>
            <th><b>C62</b> Saving vs current postage recredits</th>
            <td>{{ new_cost['saving_vs_current_postage_recredits'] }}</td>
            <td colspan="6"></td>
          </tr>
          <tr>
            <th><b>C63</b> New ink, label and postage top up cost</th>
            <td>{{ new_cost['new_ink_label_postage_top_up']['purchase'] }}</td>
            <td>{{ new_cost['new_ink_label_postage_top_up']['lease'][0] }}</td>
            <td>{{ new_cost['new_ink_label_postage_top_up']['lease'][1] }}</td>
            <td>{{ new_cost['new_ink_label_postage_top_up']['lease'][2] }}</td>
            <td>{{ new_cost['new_ink_label_postage_top_up']['lease'][3] }}</td>
            <td>{{ new_cost['new_ink_label_postage_top_up']['lease'][4] }}</td>
            <td>{{ new_cost['new_ink_label_postage_top_up']['lease'][5] }}</td>
          </tr>
          <tr>
            <th><b>C64</b> Total cost of future ownership</th>
            <td>{{ new_cost['total_cost_future_ownership']['purchase'] }}</td>
            <td>{{ new_cost['total_cost_future_ownership']['lease'][0] }}</td>
            <td>{{ new_cost['total_cost_future_ownership']['lease'][1] }}</td>
            <td>{{ new_cost['total_cost_future_ownership']['lease'][2] }}</td>
            <td>{{ new_cost['total_cost_future_ownership']['lease'][3] }}</td>
            <td>{{ new_cost['total_cost_future_ownership']['lease'][4] }}</td>
            <td>{{ new_cost['total_cost_future_ownership']['lease'][5] }}</td>
          </tr>
        </div>
      </div>
      </tbody>
    </table>
  </div>
</template>
<script>
  export default {
    props: ['new_costs', 'current_costs'],
    // updated() {
    // //  _.each(this.new_costs, cost => {
    // // //    console.log(cost['manufacturer']['name'])
    // // //    console.log(cost['outbound_shipping_application'])
    // // //  console.log(cost)
    //  })
    // },
    data() {
      return {
        letter: '',
        show_manufacturers: {
          2: true,
          3: true,
          4: true,
          5: true,
        }
      }
    },
    computed:
    {
      changed_new_cost : function()
      {
         return this.new_costs.filter(function(elem) {return elem['annual_incremental_connectivity_kit_service_cost']!= null  });
      }
    },
    methods: {
      show(id) {
        return this.show_manufacturers[id]
      },
      toggle(id) {
        this.show_manufacturers[id] = !this.show_manufacturers[id]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Debug/QuoteInfo/MachineLeaseTerms.vue